

export class ThemeEvents {

  static mediaStartedPlaying = 'media:started-playing';

  static quantitySelectorUpdate = 'quantity-selector:update';

  static megaMenuHover = 'megaMenu:hover';

  static zoomMediaSelected = 'zoom-media:selected';

  static stitchSwap = 'stitch:swap';
}

export class QuantitySelectorUpdateEvent extends Event {

  constructor(quantity, cartLine) {
    super(ThemeEvents.quantitySelectorUpdate, { bubbles: true });
    this.detail = {
      quantity,
      cartLine,
    };
  }
}

export class MediaStartedPlayingEvent extends Event {

  constructor(resource) {
    super(ThemeEvents.mediaStartedPlaying, { bubbles: true });
    this.detail = {
      resource,
    };
  }
}

export class SlideshowSelectEvent extends Event {

  constructor(data) {
    super(SlideshowSelectEvent.eventName, { bubbles: true });
    this.detail = data;
  }

  detail;

  static eventName = 'slideshow:select';
}

export class ZoomMediaSelectedEvent extends Event {

  constructor(index) {
    super(ThemeEvents.zoomMediaSelected, { bubbles: true });
    this.detail = {
      index,
    };
  }
}

export class MegaMenuHoverEvent extends Event {
  constructor() {
    super(ThemeEvents.megaMenuHover, { bubbles: true });
  }
}

export class StitchSwapEvent extends Event {

  constructor(productUrl) {
    super(ThemeEvents.stitchSwap, { bubbles: true });
    this.detail = {
      productUrl,
    };
  }
}
